<template>
    <d-container fluid class="main-content-container px-4">
        <!-- Page Header -->
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="12" class="text-center text-sm-left flex-header">
                <h3 class="page-title">Edycja pozycji w słowniku</h3>
                <d-button theme="secondary" @click.prevent="$router.push({name: 'dictionary'})"><i class="material-icons">keyboard_backspace</i> Wróć do listy</d-button>
                <d-button theme="success" @click.prevent="submitForm" :class="{isLoading: submitting}"><i class="material-icons">save</i> Zapisz zmiany</d-button>
            </d-col>
        </d-row>
        <div v-if="!fetched">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
        </div>
        <transition name="fade">
            <d-card class="card-small" v-if="fetched">

                <d-list-group flush @keyup.enter="submitForm">
                    <d-list-group-item class="p-3">
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.rzeczownik" name="rzeczownik" label="Rzeczownik" placeholder="pożyczka"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.mianownik" name="mianownik" label="Mianownik (Kto? Co?)" placeholder="pożyczka"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.dopelniacz" name="dopelniacz" label="Dopełniacz (Kogo? Czego?)" placeholder="pożyczki"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.celownik" name="celownik" label="Celownik (Komu? Czemu?)" placeholder="pożyczce"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.biernik" name="biernik" label="Biernik (Kogo? Co?)" placeholder="pożyczkę"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.narzednik" name="narzednik" label="Narzędnik (Z kim? Z czym?)" placeholder="pożyczką"></ss-input>
                            </d-col>
                        </d-row>
                        <d-row>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.miejscownik" name="miejscownik" label="Miejscownik (O kim? O czym?)" placeholder="pożyczce"></ss-input>
                            </d-col>
                            <d-col md="6" class="form-group">
                                <ss-input v-model="dictionary.wolacz" name="wolacz" label="Hej!" placeholder="pożyczko"></ss-input>
                            </d-col>
                        </d-row>
                    </d-list-group-item>
                </d-list-group>
            </d-card>
        </transition>
    </d-container>
</template>

<script>
    import LarErrors from '../helpers/Errors';

    export default {
        name: "DictionarytNew",
        components: {
            LarErrors,
        },
        data(){
            return{
                fetched: false,
                lar_errors: LarErrors,
                submitting: false,
                dictionary: {
                    id:             '',
                    rzeczownik:     '',
                    mianownik:      '',
                    dopelniacz:     '',
                    celownik:       '',
                    biernik:        '',
                    narzednik:      '',
                    miejscownik:    '',
                    wolacz:         '',
                },
            }
        },
        methods: {
            submitForm(){
                this.submitting = true;
                axios.post('api/dictionary/update/' + this.dictionary.id, this.dictionary).then(response => {
                    Vue.swal({
                        type: 'success',
                        title: 'Pozycja słownika została zapisana.',
                        showConfirmButton: true,
                    }).then(() => {
                        this.fetchData();
                    });
                    this.submitting = false;
                }).catch((error) =>{
                    this.submitting = false;
                    console.log(error);
                    LarErrors.record(error.response.data.errors)
                })
            },
            fetchData(){
                axios.post('api/dictionary/item/' + this.$route.params.id).then(response => {
                    this.dictionary = response.data.data;
                    this.fetched = true;
                }).catch(errors => {
                    console.log(errors);
                    this.fetched = true;
                })
            }
        },
        mounted(){
            this.fetchData();
            this.fetched = true;
        },
    }
</script>
